module.exports = __webpack_public_path__ + "img/hack_1.5a3f91d2.png";